import React from 'react';

const BADGES = [
  { src: '/hipaa-badge.svg', alt: 'HIPAA' },
  { src: '/fda-21cfr-part11-badge.svg', alt: 'FDA 21 CFR Part 11' },
  { src: '/eu-annex-11-badge.svg', alt: 'EU Annex 11' },
  { src: '/ich-gcp-badge.svg', alt: 'ICH GCP' },
];

const COMMITMENTS = [
  {
    icon: 'pi pi-history',
    title: 'Audit trail on every record',
    copy: 'Field-level changes, signatures, and events are captured as they happen.',
  },
  {
    icon: 'pi pi-verified',
    title: 'Part 11-minded e-signatures',
    copy: 'Signature and version workflows designed around 21 CFR Part 11 expectations.',
  },
  {
    icon: 'pi pi-lock',
    title: 'Permission-scoped access',
    copy: 'Roles, delegation logs, and granular capabilities keep access deliberate.',
  },
  {
    icon: 'pi pi-check-square',
    title: 'Inspection preparedness',
    copy: 'Documents, training, and evidence organized so review day is a formality.',
  },
];

export default function TrustStrip() {
  return (
    <section className="hx-trust" id="trust" aria-labelledby="trust-heading">
      <div className="hx-container">
        <div className="hx-trust__head">
          <h2 className="hx-trust__title" id="trust-heading">
            Built for regulated research workflows
          </h2>
          <ul className="hx-trust__badges" aria-label="Regulatory frameworks Phennx is designed around">
            {BADGES.map((badge) => (
              <li key={badge.src}>
                <img src={badge.src} alt={badge.alt} width="160" height="46" loading="lazy" />
              </li>
            ))}
          </ul>
        </div>

        <ul className="hx-trust__grid">
          {COMMITMENTS.map((item) => (
            <li className="hx-trust__item" key={item.title}>
              <i className={`${item.icon} hx-trust__icon`} aria-hidden="true" />
              <h3 className="hx-trust__item-title">{item.title}</h3>
              <p className="hx-trust__item-copy">{item.copy}</p>
            </li>
          ))}
        </ul>

        <p className="hx-trust__footnote">
          Compliance-minded by design. Framework alignment details live in the{' '}
          <a
            className="hx-link"
            href="https://compliance.phennx.io"
            target="_blank"
            rel="noreferrer"
          >
            Compliance Center
            <span className="hx-visually-hidden"> (opens in a new tab)</span>
          </a>
          .
        </p>
      </div>
    </section>
  );
}
